export default "<h1>Border-Top Rules 上边框规则</h1>\n<p>上边框填充配色规则</p>\n"